import { TopContentQuery } from "~/lib/graphql/client";
import {
  Achievement,
  DiscoveryAd as MDiscoveryAd,
} from "~/lib/server/microcms";

const categoryIds = [
  6, // 櫻坂
  200, // 福山潤
  160, // からたち
  188, // わーすた
  9, // さらば青春の光
  190, // サスペンダーズ
  178, // ぽんぽこ
  201, // みなみかわ
];

type Category = TopContentQuery["categories"][number];
type FussyEventReference = TopContentQuery["fussyEventReferences"][number];
type DiscoveryAd = MDiscoveryAd;

type Props = {
  categories: Category[];
  info: {
    title: string;
    url: string;
    date: string;
  } | null;
  fussyEventReferences: FussyEventReference[];
  discoveryAds: DiscoveryAd[];
  achievements: Achievement[];
};

export type { Category, Props, FussyEventReference, DiscoveryAd };
export { categoryIds };
